import React from 'react';

export default class BlockRight extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            minutes: this.props.time_to_do,
            seconds: 0,
            total_question : this.props.total_question,
            total_answered: this.props.total_answered,
            questions: this.props.questions,
            spend_time: 0
        };
    }

    componentWillReceiveProps(nextProps){
        this.setState({
            total_question : (this.props.total_question != nextProps.total_question) ? nextProps.total_question : this.props.total_question,
            total_answered : (this.props.total_answered != nextProps.total_answered) ? nextProps.total_answered : this.props.total_answered,
            questions : (this.props.questions != nextProps.questions) ? nextProps.questions : this.props.questions
        })
    }

    async componentDidMount() {
        this.myInterval = setInterval(() => {
            const { seconds, minutes, spend_time } = this.state;
            if(minutes == 0 && seconds == 0){
                this.handleSubmit();
            }
            this.setState({spend_time: spend_time + 1})
            if (seconds > 0) {
                this.setState(({ seconds }) => ({
                    seconds: seconds - 1
                }))
            }
            if (seconds === 0) {
                if (minutes === 0) {
                    clearInterval(this.myInterval)
                } else {
                    this.setState(({ minutes }) => ({
                        minutes: minutes - 1,
                        seconds: 59
                    }))
                }
            }
        }, 1000)
    }

    componentWillUnmount() {
        clearInterval(this.myInterval)
    }

    convertString(text){
        text = text + "";
        if(text.length<2){
            text = "0"+text;
        }
        return text
    }
    handleSubmit = () => {
        const self = this;
        const {seconds, minutes,spend_time} = this.state;
        if(minutes == 0 && seconds == 0){
            alert("Đã hết giờ làm bài!");
            setTimeout(function() { self.props.handleSubmit(spend_time); return false; }, 0);
        }else {
            if(window.confirm('Bạn có chắc muốn nộp bài?')){
                self.props.handleSubmit(spend_time);
            }else {
                return false;
            }
        }
    }

    render(){
        const { minutes, seconds,total_question, total_answered, questions, spend_time} = this.state;
        return(
            <div className="blockRight">
               <div className="blockContem">
                   <p className="conTem">
                       <span>Số câu đã làm</span>
                       <span className="textBold">{total_answered+"/"+total_question}</span>
                   </p>
                   <p className="conTem">
                       <span>Thời gian còn lại</span>
                       <span className="textBold">{this.convertString(minutes)+":"+this.convertString(seconds)}</span>
                   </p>
                </div>
                <div className="listNumber">
                    <span className="titleList">Chuyển nhanh tới câu hỏi</span>
                    <div className="blockQuestion">
                        {
                            questions.map((item, index)=>{
                                return (
                                    <a className={item.content.answered ? 'active' : ''} key={index} onClick={() => this.props.changeActiveQuestion(index)}>{index + 1}</a>
                                )
                            })
                        }
                    </div>
                    <div className="groupBtn">
                        <a className="bntSend" style={{ background: "#df7100", color: "#fff" }} onClick={this.handleSubmit}>Nộp bài</a>
                    </div>
                </div>
            </div>
        );
    }
}
